import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Alert, Panel, ProgressBar } from 'react-bootstrap';
import request from 'superagent';
import _ from 'lodash';
import ClioConnectionSettingsForm from "./ClioConnectionSettingsForm";
import { FORM_ERROR } from 'react-final-form';
import {notify} from "../../components/common/Notification/Notification";

export default class ClioConnectionSettings extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number.isRequired,
  };

  initialState = {
    isLoading: true,
    error: null,
    clioSettings: {},
  };

  state = { ...this.initialState };

  componentDidMount() {
    this.fetchConnectionSettings();
  }

  fetchConnectionSettings(refreshFromClio) {
    this.setState(this.initialState);

    return request.get(`/rpc/integrations/connections/${this.props.connectionId}/clio/settings`)
      .query({ refresh: refreshFromClio })
      .then((res) => {
        this.setState({
          isLoading: false,
          clioSettings: res.body
        });
      })
      .catch((err) => {
        console.error("Failed to fetch clio settings: ", err);

        // 404 not found just means no settings have been configured.
        this.setState({
          isLoading: false,
          error: _.get(err, 'response.status') !== 404 ? true : false
        });
      });
  };

  onSave = (clioSettings) => {
    console.log("Submit: ", clioSettings);

    return request
      .post(`/rpc/integrations/connections/${this.props.connectionId}/clio/settings`)
      .send(clioSettings)
      .then(
        res => {
          console.debug('Saved! Result:', res);
          notify.success('Clio Settings Saved');
        },
        errRes => {
          console.error('Error Saving!', errRes);
          return { [FORM_ERROR]: 'Error Saving'};
        }
      );
  }

  render() {
    const { connectionId } = this.props;

    return (
      <Fragment>
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              Clio Settings
            </Panel.Title>
          </Panel.Heading>

          <Panel.Body>{(() => {
              if (this.state.error) return (
                <Alert bsStyle="danger">
                  There was an error loading Clio Settings Information.
                  If the problem persists, please contact CourtDrive support.
                </Alert>
              );

              if (this.state.isLoading) return (
                <ProgressBar active now={100} />
              );

              return (
                <ClioConnectionSettingsForm
                  connectionId={connectionId}
                  onSave={this.onSave}
                  clioSettings={this.state.clioSettings}
                />
              );
            })()}
          </Panel.Body>
        </Panel>
      </Fragment>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Integrations/connections/ClioConnectionSettings.jsx